import { UseQueryResult } from "@tanstack/react-query";
import { useAuthQuery, UseQueryExtendedOptions, useToken } from "@bn/api";
import { loadMyself } from "@api/v1/methods";
import { UserWithType } from "@api/v1/model";

export const useMyself = (
  options?: UseQueryExtendedOptions<UserWithType, AxiosApiError, UserWithType>
): UseQueryResult<UserWithType> => {
  const { data: token, isFetched } = useToken();
  const isEnabled = options?.enabled === undefined ? true : !!options?.enabled;
  const requestData = useAuthQuery(
    ["myself"],
    ({ token }) => loadMyself(token),
    {
      ...options,
      enabled: !!token && isEnabled,
      refetchOnWindowFocus: true,
      staleTime: 0,
    }
  );

  return {
    ...requestData,
    isFetched: isFetched ? (token ? requestData.isFetched : true) : false,
    data: {
      isUserPro: false,
      isUserPlus: false,
      isUserFree: true,
      isSmartbrokerPlusExpired: false,
      ...requestData.data,
    },
  } as UseQueryResult<UserWithType>;
};
